import {
  deleteSSRCookie,
  getSSRCookie,
  setSSRCookie,
  TCookieOptions,
} from '@/common/cookies';
import { ILogoutTokenCookie } from '@/modules/auth/types';

const COOKIE_NAME = 'logoutToken';

const LOGOUT_TOKEN_MAX_AGE = 60 * 60 * 24 * 90; // 90 days

export const setLogoutToken = (
  res: TServerSideResponse,
  value: ILogoutTokenCookie,
  options?: TCookieOptions
) => {
  // * Set max age to maximum refresh token expiration time
  const maxAge = LOGOUT_TOKEN_MAX_AGE;

  setSSRCookie(res, COOKIE_NAME, value, { maxAge, ...options });
};

export const getLogoutToken = (req: TServerSideRequest) => {
  return getSSRCookie(req, COOKIE_NAME);
};

export const deleteLogoutToken = (res: TServerSideResponse) => {
  deleteSSRCookie(res, COOKIE_NAME);
};
